<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useFormatStore } from "@/stores/formatStore";
import { useLocalization, locales } from "@/locales/localization";


const formatStore = useFormatStore();
const i18n = useI18n();


const { updateLocale } = useLocalization();
</script>

<template>
  <v-menu>
    <template #activator="{ props }">
      <img
          src="@/assets/icons/svg/Global_16x16.svg"
          alt="Language Selector"
          width="16"
          height="16"
          v-bind="props"
          class="desktop language-switch__img cursor-pointer"
      />
    </template>
    <v-list>
      <v-list-item :min-width="400">
        <v-row>
          <!-- Language Selection -->
          <v-col cols="12" md="7" xl="7">
            <v-list-item
                v-for="l in locales"
                :key="l.value"
                @click="updateLocale(l.value)"
                :class="{ 'selected-locale': i18n.locale.value === l.value }"
            >
              <v-list-item-title>{{ l.label }}</v-list-item-title>
            </v-list-item>
          </v-col>

          <!-- Currency Selection -->
          <v-col cols="12" md="5" xl="5" class="separator">
            <v-list-item
                v-for="l in formatStore.currencies"
                :key="l.value"
                @click="formatStore.setCurrency(l)"
                :class="{ 'selected-currency': formatStore.isCurrencySelected(l.value) }"
            >
              <v-list-item-title>{{ l.symbol }} {{ l.code }}</v-list-item-title>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style scoped>
.separator {
  border-left: 1px solid #c0c0c0; /* Add the separating line */
}


.header-light .language-switch__img,
.header-light .drawer-menu__img {
  filter: contrast(0%) brightness(2);
}


@media (max-width: 768px) {
  .separator {
    border-left: none; /* Remove the vertical line on small screens */
    border-top: 1px solid #c0c0c0; /* Add a horizontal line on small screens */
    padding-top: 16px;
    margin-top: 16px;
  }
}
.header-light .language-switch__img,
.header-light .drawer-menu__img {
  filter: contrast(0%) brightness(2);
}
</style>